// extracted by mini-css-extract-plugin
module.exports = {"claimbutton":"Button_claimbutton__1bzbJ","label":"Button_label__36fjO","img":"Button_img__1J3sL","spinner":"Button_spinner__3j1Sf"};